const authService = {
  signUp: async (formData) => {
    localStorage.setItem('user', JSON.stringify(formData));
    return Promise.resolve();
  },
  signIn: async (email, password) => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user && user.email === email && user.password === password) {
      return Promise.resolve();
    }
    return Promise.reject(new Error('Invalid credentials'));
  },
  pinSignIn: async (pin) => {
    const user = JSON.parse(localStorage.getItem('user'));
    // Example: check if the stored user has a PIN property matching the input
    if (user && user.pin && user.pin === pin) {
      return Promise.resolve();
    }
    return Promise.reject(new Error('Invalid PIN'));
  },
  updateAWSCredentials: async (credentials) => {
    let user = JSON.parse(localStorage.getItem('user')) || {};
    user = { ...user, ...credentials };
    localStorage.setItem('user', JSON.stringify(user));
    return Promise.resolve();
  },
};

export default authService;
